export default __webpack_public_path__ + "static/penn-a380a3096ea5177cef2780ef7ce9ec08.png";